<div style="max-height: 100%">
    @if(resolvedRequests.length > 0) {
        <h3>Resolved Requests to be accepted by you</h3>
        <ul>
            @for( sr of resolvedRequests; track $index) {
                <li><a [routerLink]="getNavRoute(sr)">{{sr.refNr}}</a> {{sr.title}}</li>
            }
        </ul>
    }

    @if(openRequests.length > 0) {
        <h3>Your open requests</h3>
        <ul>
            @for( sr of openRequests; track $index) {
                <li><a [routerLink]="getNavRoute(sr)">{{sr.refNr}}</a> {{sr.title}}</li>
            }
        </ul>
    }
</div>
